export const CALLING_APPEAL_SUBMITTED = 'CALLING_APPEAL_SUBMITTED';
export const NO_CALL_ACCESS_SCOPE = 'NO_CALL_ACCESS_SCOPE';